// extracted by mini-css-extract-plugin
export default {"login":"AuthButtons_login__ZZnpb"};